import { generateIconComponent } from './icons.utils';

export const ChevronLeftLightIcon = generateIconComponent({
    name: 'ChevronLeftLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M17.7342 -9.44164e-07C18.0581 -9.15851e-07 18.382 0.123982 18.63 0.369416C19.1234 0.865343 19.1234 1.6649 18.63 2.16083L8.7873 12.0009L18.63 21.8411C19.1233 22.3345 19.1233 23.1366 18.63 23.63C18.134 24.1233 17.3345 24.1233 16.8385 23.63L6.10271 12.8941C5.8674 12.6563 5.7333 12.3349 5.7333 12.0009C5.7333 11.6644 5.8674 11.3431 6.10271 11.1052L16.8385 0.369415C17.0865 0.123982 17.4104 -9.72478e-07 17.7342 -9.44164e-07Z" />
    ),
});
